// ITEM H2 (her TestFlight test, 2026-10-18). THE ONE SENTENCE Go live shows when the camera or microphone did not open,
// chosen from where she is (the website or the store app) and what the phone says it holds. Inside the app it never says
// "browser": there is none. CLIENT-ONLY PURE LAW: imports nothing, so scripts/camera-ask-1.mjs can load and run it.

export type MediaAnswer = { camera: string; microphone: string };
export type CameraRefusal = { text: string; settings: boolean };

export const WEB_CAMERA_REFUSED =
  "This browser has not been allowed to use your camera. Allow it in your browser settings, then tap Go live again.";

/**
 * app: true in the store app. platform: "ios" or "android". answer: the phone's own record, or null when it could not say.
 * settings: true when the way out is the phone's Settings page, so the screen offers the button that opens it.
 */
export function cameraRefusal(app: boolean, platform: string, answer: MediaAnswer | null): CameraRefusal {
  if (!app) return { text: WEB_CAMERA_REFUSED, settings: false };
  const where = platform === "ios" ? "your iPhone Settings" : "your phone's Settings";
  if (answer && answer.camera !== "granted") {
    return { text: `Camera is off for 12th House. Turn it on in ${where}, then tap Go live again.`, settings: true };
  }
  if (answer && answer.microphone !== "granted") {
    return { text: `Microphone is off for 12th House. Turn it on in ${where}, then tap Go live again.`, settings: true };
  }
  // Both allowed (or the phone could not say) and the camera still did not open: another app may be holding it.
  return { text: "Your camera could not be opened just now. Close this, then tap Go live again.", settings: false };
}
